const styles = theme => ({
  addMore: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    border: '1px dashed #919EAB52',
    borderRadius: '8px',
    gap: 8,
    padding: '4px 16px',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    backgroundColor: '#F8FAFC',
  },

  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: '100%',
  },
  attachmentRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    padding: '12px 16px',
    borderRadius: '8px',
    alignItems: 'center',
    backgroundColor: '#F8FAFC',
  },
  fileName: {
    fontSize: '13px',
    fontWeight: 400,
    color: '#002E47',
  },
  flexGrow: {
    flexGrow: 1,
  },
  fileIcon: {
    fontSize: '16px',
    minWidth: '16px',
  },
  fileIconError: {
    color: '#015FFB',
  },
  fileIconSuccess: {
    color: '#29D25D',
  },
  uploadedText: {
    fontSize: '14px',
    fontWeight: 500,
  },
  closeIcon: {
    fontSize: '16px',
    color: '#ED4245',
    cursor: 'pointer',
  },
  tickIcon: {
    fontSize: '16px',
    color: '#29D25D',
  },
  iconDefault: {
    fontSize: '16px',
    color: '#919EAB',
    marginTop: 3,
  },
  iconHovered: {
    fontSize: '16px',
    color: '#015FFB',
    marginTop: 3,
  },
  textDefault: {
    fontSize: '14px',
    color: '#919EAB',
  },

  circularProgress: {
    minWidth: '16px',
  },
})

export default styles
